import { AnalyticsEventType } from '@/services/analytics/platforms/adobe-analytics/models';
import { FindAChipotleClickEvent } from '@/services/analytics/events';
import { AdobeBaseEvent } from './adobe-base-event';
import { AppState } from '@/store';
import { Store } from 'vuex';
import { ServicesContainer } from '@/services';
import { RetrievalType } from '../constants';
import { getWebPageName } from '../helpers';

export class AdobeStoreLocatorClickEvent extends AdobeBaseEvent {
  event = AnalyticsEventType.LinkClicked;

  constructor(event: FindAChipotleClickEvent, store: Store<AppState>, services: ServicesContainer) {
    super(store, services);
    const type = event.eventType;
    const fac = 'Find A Chipotle';

    this.web.webInteraction = {
      name: type,
      linkClicks: { value: 1},
      type: 'other',
    };

    if(this.web.webPageDetails.pageType === 'meal-builder') {
      this.commerce.productViews = { value: 1 };
      if (store.state.restaurant?.selectedRestaurant?.restaurantNumber) {
        this.commerce.localizedBuilderView = { value: 1 };
      }
    }

    switch (type) {
      case 'searchInitiated':
        this.storeLocator.searchInitiated = { value: 1 };
        this.storeLocator.searchType = event.searchType ?? '';
        this.web.webInteraction.linkModuleName = `${fac}|Pickup Location Input|Search Initiated`;
        break;
      case 'locationSelected':
        this.storeLocator.locationSelected = { value: 1 };
        this.storeLocator.searchType = `${event.searchType} Selected`;
        this.web.webInteraction.linkModuleName = `${fac}|Restaurant List|Restaurant Selected`;
        break;
      case 'restaurantFavorited':
        this.storeLocator.restaurantFavorited = { value: 1 };
        this.web.webInteraction.linkModuleName = `${fac}|Heart Icon|Restaurant Favorited`;
        break;
      case 'directionsClicked':
        this.storeLocator[type] = { value: 1 };
        this.web.webInteraction.linkModuleName = `${fac}|Restaurant Details|Directions Clicked`;
        break;
      case 'pickupLocation':
        this.storeLocator.pickupLocation = { value: 1 };
        this.commerce.storeSetMethod = 'customer';
        this.web.webInteraction.linkModuleName = `${fac}|Restaurant Details|Pickup From This Restaurant`;
        if(store.state.order.lastRetrievalType === RetrievalType.Delivery) {
          this.commerce.changeToPickup = {'value': 1};
          this.web.webPageDetails.name = getWebPageName();
        }
        break;
      case 'deliveryAddressLookup':
        this.storeLocator.deliveryAddressLookup = { value: 1 };
        this.storeLocator.searchType = event.searchType ?? '';
        this.web.webInteraction.linkModuleName = `${fac}|Delivery Address Input|Delivery Address Lookup`;
        break;
      case 'addAddressDetails':
        this.storeLocator.addAddressDetails = { value: 1 };
        this.web.webInteraction.linkModuleName = `${fac}|Delivery Address Details|Add Address Details`;
        break;
      case 'addSavedAddressDetails':
        this.storeLocator.addAddressDetails = { value: 1 };
        this.web.webInteraction.linkModuleName = `${fac}|Delivery Address Details|Add Address Details`;
        if(store.state.order.lastRetrievalType === RetrievalType.Pickup) {
          this.commerce.changeToDelivery = {'value': 1};
          this.web.webPageDetails.name = getWebPageName();
        }
        break;
      case 'cateringCTA':
        this.storeLocator.cateringCTA = { value: 1 };
        this.web.webInteraction.linkModuleName = `${fac}||Deliver To This Address`;
        break;
    }
  }
}
